const url = process.env.REACT_APP_API_BASE_URL;

export const getBaseUrl = () =>{return  url}